import { UPDATE_LOCATION_FOR_MANAGE_USERS } from '../constants/action-types';
export const updateLocationForManageUsers = ({ institutionMemberId, locationId, }) => ({
    type: UPDATE_LOCATION_FOR_MANAGE_USERS,
    payload: {
        locationId,
        institutionMemberId,
    },
});
